<app-page-header title="Settings"></app-page-header>

<div>
	<h2 class="font-semibold text-lg">
		<span class="mr-2"><fa-icon [icon]="['far', 'envelope']"></fa-icon></span>
		<span>E-Mail Notifications</span>
	</h2>
</div>
<!-- <form> -->

<div class="flex w-full py-4 gap-2 items-center">
	<div>
		<label for="email-notification">Enable E-Mail notification</label>
		<p class="opacity-50">Lorem ipsum dolor sit amet consectetur.</p>
	</div>
	<div class="ml-auto flex items-center">
		<p-toggleswitch inputId="email-notification" [(ngModel)]="allNotificationsEnabled" (onChange)="toggleAllNotifications()">
		</p-toggleswitch>
	</div>
</div>
<div class="flex items-center justify-between mb-4">
	<div></div>
	<div>
		<label for="table-search" class="sr-only">Search</label>
		<p-iconfield>
			<p-inputicon>
				<fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
			</p-inputicon>
			<input type="search" pInputText id="table-search" (search)="onSearchEvent()" placeholder="Search..." />
		</p-iconfield>
	</div>
</div>
<div></div>
<p-accordion [multiple]="true">
	@for (group of groups; track group.groupName) {
	<p-accordion-panel [value]="$index">
		<p-accordion-header>
			<div class="flex items-center w-full">
				<div>
					<span>{{ group.groupName }} </span>
					<span class="text-sm">
						(
						{{ getEnabledGatewaysCount(group) }}
						/
						{{ group.gateways.length }}
						enabled)
					</span>
				</div>

				<div class="ml-auto flex flex-row gap-4 mr-8">
					<!-- <p-toggleswitch [(ngModel)]="gw.notificationsEnabled">
                        <ng-template #handle let-checked="checked">
                            <fa-icon
                                [icon]="['far', checked ? 'bell' : 'bell-slash']"
                                [fixedWidth]="true"
                            ></fa-icon>
                        </ng-template>
                    </p-toggleswitch> -->

					<p-button [size]="'small'" variant="text" (click)="toggleGroupNotifications($event, group, true)">
						<fa-icon [icon]="['far', 'bell']"></fa-icon>
						<span>Enable all</span>
					</p-button>
					<p-button [size]="'small'" variant="text" (click)="toggleGroupNotifications($event, group, false)">
						<fa-icon [icon]="['far', 'bell-slash']"></fa-icon>
						<span>Disable all</span>
					</p-button>
				</div>
			</div>
		</p-accordion-header>
		<p-accordion-content>
			<div *ngFor="let gw of group.gateways; index as gatewayIndex" class="flex items-center py-2">
				<div>
					<label for="name-{{ $index }}-{{ gatewayIndex }}"> {{ gw.name }}</label>
				</div>
				<div class="ml-auto flex items-center">
					<p-toggleswitch [(ngModel)]="gw.notificationsEnabled" inputId="name-{{ $index }}-{{ gatewayIndex }}"> </p-toggleswitch>
					<!-- <span class="ml-2">
						<fa-icon
							[icon]="[
								'far',
								gw.notificationsEnabled ? 'bell' : 'bell-slash'
							]"
							[fixedWidth]="true"
						></fa-icon>
						<span>
							{{
								gw.notificationsEnabled ? "Enabled" : "Disabled"
							}}
						</span>
					</span> -->
				</div>
			</div>
		</p-accordion-content>
	</p-accordion-panel>
	}
</p-accordion>
<!-- </form> -->

<!-- <ng-template #handle let-checked="checked">
	<fa-icon
		[icon]="['far', checked ? 'bell' : 'bell-slash']"
		[fixedWidth]="true"
	></fa-icon>
</ng-template> -->
<div class="mt-24">
	<div class="flex items-center justify-between mb-4">
		<div></div>
		<div>
			<label for="table-search" class="sr-only">Search</label>
			<p-iconfield>
				<p-inputicon>
					<fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
				</p-inputicon>
				<input type="search" pInputText id="table-search" (search)="onSearchEvent()" placeholder="Search..." />
			</p-iconfield>
		</div>
	</div>
	<div class="mb-4 flex items-center gap-2">
		<p-button [text]="true">
			<fa-icon [icon]="['fas', 'rotate-right']"></fa-icon>
			<span class="ml-2 sr-only">Reload gateways</span>
		</p-button>
		<p-button [outlined]="true">
			<span>Clear</span>
			<fa-icon class="ml-2" [icon]="['fas', 'filter-circle-xmark']"></fa-icon>
		</p-button>
		<div class="ml-auto">
			<p-paginator
				(onPageChange)="onPageChange()"
				[first]="first"
				[rows]="($filter | async)?.per_page"
				[totalRecords]="($filter | async)?.total"
				[rowsPerPageOptions]="rowsPerPageOptions"
				[showCurrentPageReport]="true"
				currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
		</div>
	</div>
	<p-table [value]="groups" dataKey="id" [tableStyle]="{ 'min-width': '60rem' }" [expandedRowKeys]="expandedRows">
		<ng-template #caption>
			<div class="flex flex-wrap justify-end gap-2">
				<p-button variant="text" (click)="expandAll()">
					<fa-icon [icon]="['fas', 'plus']"></fa-icon>
					<span>Expand All</span>
				</p-button>
				<p-button variant="text" (click)="collapseAll()">
					<fa-icon [icon]="['fas', 'minus']"></fa-icon>
					<span>Collapse All</span>
				</p-button>
			</div>
		</ng-template>
		<ng-template #header>
			<tr>
				<th pSortableColumn="property">Property <p-sortIcon field="property" /></th>
				<th></th>
			</tr>
		</ng-template>
		<ng-template #body let-group let-expanded="expanded">
			<tr>
				<td>
					<p-button variant="text" [pRowToggler]="group">
						{{ group.groupName }}
					</p-button>
					<span class="text-sm">
						(
						{{ getEnabledGatewaysCount(group) }}
						/
						{{ group.gateways.length }}
						enabled)
					</span>
				</td>
				<td>
					<div class="flex flex-wrap justify-end gap-2 items-center">
						<p-button [size]="'small'" variant="text" (click)="toggleGroupNotifications($event, group, true)">
							<fa-icon [icon]="['far', 'bell']"></fa-icon>
							<span>Enable all</span>
						</p-button>
						<p-button [size]="'small'" variant="text" (click)="toggleGroupNotifications($event, group, false)">
							<fa-icon [icon]="['far', 'bell-slash']"></fa-icon>
							<span>Disable all</span>
						</p-button>
						<p-button variant="text" [pRowToggler]="group">
							<fa-icon [icon]="['fas', expanded ? 'chevron-up' : 'chevron-down']"></fa-icon>
						</p-button>
					</div>
				</td>
			</tr>
		</ng-template>
		<ng-template #expandedrow let-group>
			<tr>
				<td colspan="2">
					<div class="p-4">
						<h5 class="mb-2 font-medium">Gateways of {{ group.groupName }}</h5>
						<p-table [value]="group.gateways" dataKey="id">
							<ng-template #header>
								<tr>
									<th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
									<th style="width: 4rem"></th>
								</tr>
							</ng-template>
							<ng-template #body let-gateway>
								<tr>
									<td>{{ gateway.name }}</td>
									<td>
										<p-toggleswitch [(ngModel)]="gateway.notificationsEnabled"></p-toggleswitch>
									</td>
								</tr>
							</ng-template>
							<ng-template #emptymessage>
								<tr>
									<td colspan="2">There are no gateways for this property yet.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
